module.exports = __webpack_public_path__ + "static/rainbowspot5-9065028e0e5f0ba9e8845f04aae4016b.png";